import React from 'react';

/**
 * Sélecteur de genre (Monsieur / Madame)
 * Aucune option n'est sélectionnée par défaut
 */
function ChampGenre({ valeur, onChange, nom }) {
  return (
    <div className="champ">
      <label className="champ__label">Civilité</label>
      <div className="genre-select">
        <div
          className={`genre-select__option${valeur === 'M.' ? ' genre-select__option--actif' : ''}`}
          onClick={() => onChange(nom || 'genre', 'M.')}
        >
          🕺 M.
        </div>
        <div
          className={`genre-select__option${valeur === 'Mme' ? ' genre-select__option--actif' : ''}`}
          onClick={() => onChange(nom || 'genre', 'Mme')}
        >
          💃 Mme
        </div>
      </div>
    </div>
  );
}

export default ChampGenre;
